


import { Routes, RouterModule } from '@angular/router';
import { ExtensionAttributeComponent } from './extensionattribute.component';

const routes: Routes = [
    {
        path: '',
        component: ExtensionAttributeComponent
    },
];

export const ExtensionAttributeRoutes = RouterModule.forChild(routes);
